let ENV = process.env.VUE_APP_CURRENTMODE; //获取环境变量
// console.log(ENV)
let webSocketUrl = '';
let mobileSignUrl = '';
let currentUrl = "";
let socketIo = "";
let isHttps = false;
switch (ENV) {
  case 'testing':
    webSocketUrl = 'wss://test.xcontract.cn';
    //手绘签名的地址
    mobileSignUrl = "https://test.xcontract.cn/m";
    currentUrl = "https://test.xcontract.cn";
    socketIo = "ws://47.94.74.150:50001"
    break;
  case 'preview':
    webSocketUrl = 'ws://10.8.1.44:8080';
    mobileSignUrl = "http://m.xcontract.cn";
    currentUrl = "http://www.xcontract.cn";
    socketIo = "ws://47.94.74.150:50001"
    break;
  case 'product':
    webSocketUrl = 'wss://www.xcontract.cn';
    mobileSignUrl = "http://m.xcontract.cn";
    currentUrl = "http://www.xcontract.cn";
    socketIo = "wss://www.xcontract.cn";
    isHttps = true;
    break;
  case 'advance':
    // console.log('本地启动预发环境')
    break;
  default:
    webSocketUrl = 'wss://test.xcontract.cn';
    mobileSignUrl = "https://test.xcontract.cn";
    currentUrl = "https://test.xcontract.cn";
    socketIo = "wss://www.xcontract.cn"
}
let GlobalConfig = {
  webSocketUrl: webSocketUrl,
  mobileSignUrl: mobileSignUrl,
  currentUrl: currentUrl,
  socketIo: socketIo,
  isHttps: isHttps,
  ENV: ENV
}
console.log(GlobalConfig);
export default GlobalConfig;